<template>
	<div class="sidebar">
		<div class="sidebar_title">
			<!-- 头像 -->
			<img class="photo" :src="userInfo.avatar || image" alt="" />
			<!-- 名称 -->
			<div class="sidebar_name">
				<h5>{{ userInfo.UserName }}</h5>
				<span>{{ userInfo.Account }}</span>
			</div>
		</div>
		<div class="mailbox-folder">邮箱文件夹</div>
		<!-- 导航 -->
		<div class="list-item">
		  <SidebarList :number="unrendNumber" @closeDialogue="closeDia" :list="list" :pid="pid" />
		</div>
		<!-- 设置按钮 -->
		<!-- <span class="setting"><van-icon name="setting-o" /></span> -->
	</div>
</template>

<script>
import SidebarList from './SidebarList.vue'
import { mapState } from 'vuex'
import image from "@/assets/img/defaultimage.png"
export default {
  name: "Sidebar",
  props: {
    list: {
      type: Array,
      require: true
    },
    isShow: {
      type: Boolean,
      require: true,
    },
	pid: {
			type: String,
			require: true
		}
  },
  data() {
    return {
      show: true,
	  unrendNumber: '',
	  image: image
    }
  },
  created() {
	  this.getUnrendEmil() // 获取未读数
  },
  components: {
    SidebarList,
  },
  computed: {
	// 获取用户信息
    userInfo() {
      return this.$store.state.User.userInfo
    }
  },
  methods: {
	//   关闭弹层
    closeDia(val) {
      this.$emit("handelClose", val)
    },
	// 获取未读数
  async getUnrendEmil() {
	  const res = await this.$api.getEmaNotRead()
	  this.unrendNumber = res.Data
  }
  }
}
</script>

<style lang="less" scoped>
.sidebar_title {
	position: fixed;
	top: 10px;
	width: 100%;
	// position: relative;
	display: flex;
	align-items: center;
	text-align: start;
	height: 62px;
	// margin-top: 10px;
	z-index: 9999;
	&::after {
		content: '';
		position: absolute;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 1px;
		background-color: #e5e5e5;
		transform-origin: 0 0;
	}

	.sidebar_name {
		display: flex;
		flex-direction: column;
		justify-content: center;
		font-size: 14px;
		h5 {
			margin: 0;
			padding: 0;
			font-size: 14px;
		}
		span {
			color: #999999;
			font-size: 12px;
		}
	}
	.photo {
		margin: 0 12px 0 16px;
		width: 36px;
		height: 36px;
		border-radius: 50%;
		background-color: rgb(163, 158, 158);
		overflow: hidden;
	}
}
.mailbox-folder {
	margin: 82px 0 6px 16px;
	color: #999999;
	font-size: 14px;
	text-align: left;
}
.setting {
	position: absolute;
	left: 16px;
	bottom: 16px;
}
.list-item {
	height: calc(100vh - 104px);
	overflow: scroll;
}
</style>
